module.exports = __webpack_public_path__ + "img/img3.9e649fff.png";